(function () {
    function initVideoControls() {
        document.querySelectorAll('.deferred-media').forEach(container => {
            const btn = container.querySelector('.play-pause-btn');
            const video = container.querySelector('video');
            const poster = container.querySelector('.video-poster');
            
            if (!btn || !video) return;
            
            let isPlaying = false;
            let hasStartedPlaying = false;
            video.muted = true;
            video.playsInline = true;
            
            function toggle() {
                if (isPlaying) {
                    video.pause();
                } else {
                    video.play().catch(() => {});
                }
            }
            
            function updateState(playing) {
                isPlaying = playing;
                btn.classList.toggle('playing', playing);
                btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
                container.classList.toggle('playing', playing);
                
                if (playing) {
                    hasStartedPlaying = true;
                }
                
                if (poster) {
                    if (hasStartedPlaying) {
                        poster.style.display = 'none';
                    } else {
                        poster.style.display = playing ? 'none' : 'block';
                    }
                }
            }
            
            btn.addEventListener('click', e => { e.preventDefault(); toggle(); });
            video.addEventListener('click', e => { e.preventDefault(); toggle(); });
            if (poster) poster.addEventListener('click', e => { e.preventDefault(); toggle(); });
            
            video.addEventListener('play', () => updateState(true));
            video.addEventListener('pause', () => updateState(false));
            video.addEventListener('ended', () => updateState(false));
            
            if (video.autoplay) {
                updateState(true);
            }
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoControls);
    } else {
        initVideoControls();
    }
    
    document.addEventListener('shopify:section:load', initVideoControls);
})();